import { AttributeType, ClassificationType } from "@evergis/api";

import { ClassifyType } from "../../../../interfaces/classification";

export const getAttributeTypeAlgorithms = (type: AttributeType): ClassifyType[] => {
  switch (type) {
    case AttributeType.Int32:
    case AttributeType.Int64:
    case AttributeType.Double:
    case AttributeType.DateTime:
      return [
        ClassificationType.Quantile,
        ClassificationType.EqualInterval,
        ClassificationType.NaturalBreaks,
        ClassificationType.Unique,
      ];
    case AttributeType.String:
      return [ClassificationType.Unique];
    default:
      return [];
  }
};
